import React from 'react'
import Alert from '../../../../itrust_common/components/Alert';
import { orderUpdate } from '../../../../redux/actions/order/orderActions';
import { appointmentLoad } from '../../../../redux/actions/appointmentActions';
import { useDispatch } from 'react-redux';

export default function UnFinalizeButton(props) {
  const { appointmentId, children, orderId } = props;
  const dispatch = useDispatch()

  const handleOrderUpdate = (data) => {
    Alert.confirm("Are you sure you want to unfinalize this order?",
      (response) => {
        if (response)
          dispatch(orderUpdate({ id: orderId, status: 'unfinished' }, { include: '*' }));
        if (data.appointmentId) setTimeout(() => {
          dispatch(appointmentLoad(data.appointmentId, { include: ['patient', 'staff', 'procedures', 'examination', 'order'] }))
        }, 1000)
      })
  }

  return (
    <span className="pointer" onClick={() => handleOrderUpdate({ appointmentId })} >
      {children}
    </span>
  )
}
